import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";
import { Link, useNavigate, useParams } from "react-router-dom";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
//@ts-ignore
import { classNames } from "../../utils/classNames";
import { useState } from "react";
import Modal from "../Reusable/Modal";
import OtherCharges from "../DeliveryCharge/OtherCharges";
import usePatchHook from "../../customHooks/usePatchHook";

const DeliveryChargeTemplateList = () => {
  const navigate = useNavigate();
  const handleRowClick = (row: any) => {
    navigate(`edit/${row.original.id}?type=${isactive}`);
  };

  const [isactive, setISactive] = useState("merchant");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const id = selectedId;
  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`delivery-charge-template`],
    navigateURL: "/",
  });
  const [selectedCharges, setSelectedCharges] = useState<any>({});

  const handleUpdateCharges = async (values: any, setError: any) => {
    if (!selectedId) return;

    const url = `${APIS.DELIVERY_CHARGE_TEMPLATE}${selectedId}/`;

    let formData = {
      other_charges: {
        ...values,
      },
    };

    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Total Delivery Charge",
      accessorKey: "total_delivery_charge",
      cell: ({ row, getValue }: any) => <>{getValue() ? getValue() : 0}</>,
    },
    {
      header: "Other Charge",
      accessorKey: "other_charge",
      cell: ({ row, getValue }: any) => (
        <>
          <div
            onClick={(e) => {
              e.stopPropagation();
              setSelectedId(row?.original?.id);
              setSelectedCharges({ ...row.original.other_charges });
              setIsOpen(true);
            }}
          >
            {getValue() ? getValue() : "view charges"}
          </div>
        </>
      ),
    },
    {
      header: "Delivery Charge",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <div
            className={tw`whitespace-nowrap`}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {isactive === "branch" ? (
              <Link to={`/branch-charge/${getValue()}`}>
                View Branch Charge
              </Link>
            ) : (
              <Link to={`/delivery-charge/${getValue()}`}>
                View Delivery Charge
              </Link>
            )}
          </div>
        </>
      ),
    },

    // {
    //   header: "Action",
    //   accessorKey: "id",
    //   cell: ({ row, getValue }: any) => (
    //     <>
    //       <AccessControl
    //         children={<TableActionButton editPath={`edit/${getValue()}`} />}
    //         allowedPermissions={["can_update_setting"]}
    //       />
    //     </>
    //   ),
    // },
  ];
  return (
    <DataTable
      url={APIS.DELIVERY_CHARGE_TEMPLATE}
      queryKey={`delivery-charge-template-${isactive}`}
      columns={defaultColumns}
      addNewPagePath={"/create"}
      onRowClick={handleRowClick}
      tableName={"rate-template"}
      params={{
        is_branch: isactive === "branch" ? true : false,
      }}
      actionMenu={
        <>
          <div className={tw`flex w-full justify-end`}>
            <div className={tw`flex  border mr-2   rounded-full `}>
              <button
                onClick={() => setISactive("branch")}
                className={classNames(
                  isactive === "branch"
                    ? tw`bg-primary text-white px-3`
                    : tw`px-2`,
                  tw`focus:outline-none  rounded-full whitespace-nowrap py-2 `
                )}
              >
                Branch
              </button>
              <button
                onClick={() => setISactive("merchant")}
                className={classNames(
                  isactive === "merchant"
                    ? tw`bg-primary text-white  px-3`
                    : tw`px-2`,
                  tw`focus:outline-none px-2 rounded-full whitespace-nowrap py-2`
                )}
              >
                Merchant
              </button>
            </div>
          </div>
          <Modal
            isOpen={isOpen}
            setIsOpen={() => {
              setIsOpen(false);
            }}
            title={"Other Charges"}
          >
            <OtherCharges
              setIsOpen={setIsOpen}
              selectedId={selectedId}
              existingCharges={selectedCharges}
              updateCharges={(data) => handleUpdateCharges(data, () => {})}
            />
          </Modal>
        </>
      }
    />
  );
};

export default DeliveryChargeTemplateList;
